var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaticMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_37046)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2963_37046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.51 56.523C30.5041 56.6516 30.4488 56.7729 30.3557 56.8618C30.2625 56.9506 30.1387 57.0001 30.01 57C29.72 57 29.5 56.79 29.49 56.523C29.345 53.355 27.734 51.306 24.658 50.376C14.53 47.968 7 38.863 7 28C7 15.297 17.297 5 30 5C42.703 5 53 15.297 53 28C53 38.863 45.47 47.968 35.342 50.376C32.266 51.306 30.655 53.356 30.512 56.523H30.51Z",
    fill: "#FF3333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.51 56.523C30.5041 56.6516 30.4488 56.7729 30.3557 56.8618C30.2625 56.9506 30.1387 57.0001 30.01 57C29.72 57 29.5 56.79 29.49 56.523C29.345 53.355 27.734 51.306 24.658 50.376C14.53 47.968 7 38.863 7 28C7 15.297 17.297 5 30 5C42.703 5 53 15.297 53 28C53 38.863 45.47 47.968 35.342 50.376C32.266 51.306 30.655 53.356 30.512 56.523H30.51Z",
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 68C27.79 68 26 66.21 26 64C26 61.79 27.79 60 30 60C32.21 60 34 61.79 34 64C34 66.21 32.21 68 30 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 66C30.2663 66.006 30.5311 65.9588 30.779 65.861C31.0268 65.7633 31.2526 65.617 31.4431 65.4308C31.6336 65.2446 31.785 65.0222 31.8884 64.7766C31.9918 64.5311 32.0451 64.2674 32.0452 64.001C32.0452 63.7346 31.9921 63.4708 31.8888 63.2253C31.7855 62.9797 31.6343 62.7572 31.4438 62.5709C31.2534 62.3846 31.0277 62.2382 30.7799 62.1403C30.5321 62.0425 30.2673 61.9951 30.0009 62.001C29.4784 62.0125 28.9811 62.2282 28.6156 62.6018C28.25 62.9754 28.0453 63.4773 28.0452 64C28.045 64.5227 28.2495 65.0246 28.6149 65.3984C28.9802 65.7722 29.4774 65.9882 30 66Z",
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 28,
    r: 6,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2963_37046",
    x: 1,
    y: -1,
    width: 58,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_2963_37046"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_37046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticMark);
export default __webpack_public_path__ + "static/media/staticMark.71f8c5d1ea7991c263cbc2a4997591cf.svg";
export { ForwardRef as ReactComponent };